import { RouteObject } from 'react-router-dom';
import { NewsletterRoutes } from '@leagueplatform/engen-capability-newsletter';
import { FormsLibraryRoutes } from '@leagueplatform/engen-capability-forms-web';
import {
  APP_MANAGED_ROUTES,
  FEATURE_FLAGS,
  FeatureFlagConditionalPage,
} from '@highmark-web/highmark-common';
import {
  AccountManagementRoutes,
  CoordinationOfBenefitsRoutes,
  DocumentCenterRoutes,
  EasyPlanFAQRoutes,
  EasyPlanRoutes,
  GlossaryRoutes,
  SpendingAccountBenefitsRoutes,
  SpendingAccountFundsRoutes,
  SpendingAccountTransactionsRoutes,
  CopayGoRoutes,
  CardManagementActivateCardRoutes,
  CardManagementOrderCardRoutes,
  CardManagementReportCardRoutes,
} from 'components/lazy-routes.component';
import { useGetAppFeatureFlag } from 'hooks/use-get-app-feature-flag.hook';

const accountManagementPaths = [
  APP_MANAGED_ROUTES.ACCOUNT_MANAGEMENT,
  APP_MANAGED_ROUTES.ACCOUNT_MANAGEMENT_CONTACT_INFORMATION,
  APP_MANAGED_ROUTES.ACCOUNT_MANAGEMENT_COMMUNICATION_PREFERENCE,
  APP_MANAGED_ROUTES.ACCOUNT_MANAGEMENT_DONATE_LIFE_REGISTRY,
  APP_MANAGED_ROUTES.ACCOUNT_MANAGEMENT_PAGE,
];

const documentCenterPaths = [
  APP_MANAGED_ROUTES.DOCUMENT_CENTER,
  APP_MANAGED_ROUTES.DOCUMENT_CENTER_ID,
];

export const EngenSDKRoutes: RouteObject[] = [
  ...accountManagementPaths.map((path) => ({
    path,
    element: <AccountManagementRoutes />,
  })),
  {
    path: APP_MANAGED_ROUTES.COORDINATION_OF_BENEFITS,
    element: <CoordinationOfBenefitsRoutes />,
  },
  ...documentCenterPaths.map((path) => ({
    path,
    element: <DocumentCenterRoutes />,
  })),
  {
    path: APP_MANAGED_ROUTES.EASY_PLAN_FAQ,
    element: <EasyPlanFAQRoutes />,
  },
  {
    path: APP_MANAGED_ROUTES.EASY_PLAN_HOME,
    element: <EasyPlanRoutes />,
  },
  {
    path: `${APP_MANAGED_ROUTES.FORMS_LIBRARY}/*`,
    element: (
      <FeatureFlagConditionalPage
        useGetAppFeatureFlag={useGetAppFeatureFlag}
        flagName={FEATURE_FLAGS.FORMS_LIBRARY}
      >
        <FormsLibraryRoutes />
      </FeatureFlagConditionalPage>
    ),
  },
  {
    path: `${APP_MANAGED_ROUTES.GLOSSARY}/*`,
    element: <GlossaryRoutes />,
  },
  {
    path: `${APP_MANAGED_ROUTES.NEWSLETTER}/*`,
    element: (
      <FeatureFlagConditionalPage
        useGetAppFeatureFlag={useGetAppFeatureFlag}
        flagName={FEATURE_FLAGS.PWP}
      >
        <NewsletterRoutes />
      </FeatureFlagConditionalPage>
    ),
  },
  {
    path: `${APP_MANAGED_ROUTES.SPENDING_ACCOUNT_BENEFITS}/*`,
    element: <SpendingAccountBenefitsRoutes />,
  },
  {
    path: `${APP_MANAGED_ROUTES.SPENDING_ACCOUNT_USE_FUNDS}/*`,
    element: <SpendingAccountFundsRoutes />,
  },
  {
    path: `${APP_MANAGED_ROUTES.SPENDING_ACCOUNT_RECENT_TRANSACTIONS}/*`,
    element: <SpendingAccountTransactionsRoutes />,
  },
  {
    path: APP_MANAGED_ROUTES.COPAY_GO,
    element: <CopayGoRoutes />,
  },
  {
    path: `${APP_MANAGED_ROUTES.CARD_MANAGEMENT_ACTIVATE_CARD}/*`,
    element: <CardManagementActivateCardRoutes />,
  },
  {
    path: `${APP_MANAGED_ROUTES.CARD_MANAGEMENT_ORDER_CARD}/*`,
    element: <CardManagementOrderCardRoutes />,
  },
  {
    path: `${APP_MANAGED_ROUTES.CARD_MANAGEMENT_REPORT_CARD}/*`,
    element: <CardManagementReportCardRoutes />,
  },
];
